/**
 * Cookie ヘッダー文字列から指定 Cookie の値を取り出す純粋関数。
 *
 * ここでは渡された文字列のパースのみを行う
 * Nuxt の useCookie は SSR / 初期描画時点のスナップショットを返すため、
 * 描画後にセットされた最新値が必要な箇所ではこちらを使う。
 * @param cookieHeader `document.cookie` 等の "a=1; b=2" 形式の文字列
 * @param name 取り出す Cookie 名
 * @returns Cookie 値。存在しない / 空文字の場合は undefined。
 */
export const parseCookieValue = (cookieHeader: string, name: string): string | undefined => {
  const target = `${name}=`;
  for (const segment of cookieHeader.split(';')) {
    const trimmed = segment.trim();
    if (trimmed.startsWith(target)) {
      const value = trimmed.slice(target.length);
      // 空文字 Cookie（name=）は未設定と同等に扱う
      if (value === '') return undefined;
      try {
        return decodeURIComponent(value);
      } catch {
        return undefined;
      }
    }
  }
  return undefined;
};
